import { Component, Injector, OnDestroy, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Configuration } from '../../../config/configuration';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { StorageService } from '../../../core/services/storage.service';
import { BaseComponent } from '../../../shared/components/base.component';

interface LoginForm {
  userEmail: string;
  userAccount: string;
}

@Component({
  selector: 'sigv-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent extends BaseComponent implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject();

  loginFormModel: LoginForm;
  isAzureAdEnable?: boolean;

  indexUrl = '';

  constructor(
    protected injector: Injector,
    private authenticationService: AuthenticationService,
    private router: Router,
    private configuration: Configuration,
    private route: ActivatedRoute,
    private storageService: StorageService
  ) {
    super(injector);
    this.loginFormModel = {
      userEmail: '',
      userAccount: ''
    };
    this.isAzureAdEnable = this.appConfig.getAzureAD().enabled;
  }

  ngOnInit(): void {
    if (this.isAzureAdEnable === true) {
      this.authenticationService.aadLoginState$
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (state) => {
            if (state !== null) {
              this.loginResponseHandler(state);
            }
          },
          error: (err) => {
            this.loginResponseHandler(false);
          }
        });

      // 開啟 AAD 時可直接登入
      if (this.authenticationService.checkIdTokenExpiration() === false) {
        if (this.authenticationService.isAuthenticated) {
          this.authenticationService.aadLoginStateSubject$.next(true);
        } else {
          this.authenticationService.refreshToken();
        }
      } else {
        this.authenticationService.clearLoginData();
        this.authenticationService.loginAzureAd();
      }
    }

    const queryParams = this.route.snapshot.queryParams;
    this.indexUrl =
      queryParams.redirectPath ?? this.configuration.routePath.index;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  login($event: Event, form: NgForm): void {
    $event.preventDefault();
    if (form.valid) {
      this.authenticationService
        .login(this.loginFormModel.userAccount.trim())
        .pipe(takeUntil(this.destroy$))
        .subscribe(this.loginResponseHandler.bind(this));
    }
  }

  private loginResponseHandler(isSuccess: boolean): void {
    if (isSuccess) {
      const urlTree = this.router.parseUrl(this.indexUrl);
      let navigateUrl = this.indexUrl;
      if (urlTree.queryParams.companyId){
        const companyId = urlTree.queryParams.companyId;
        delete urlTree.queryParams.companyId;
        navigateUrl = `/${companyId}${urlTree.toString()}`;
      }
      this.storageService.local.setItem('reloadUrl', navigateUrl);
      this.router.navigateByUrl(navigateUrl);
    } else {
      const loginFailTitle = this.translateService.instant('SigvLibrary.Error');
      const loginFailMessage = this.translateService.instant(
        'SigvLibrary.LoginFail'
      );
      this.dialogService.showErrorDialog(
        [
          {
            description: loginFailMessage,
          },
        ],
        loginFailTitle,
        () => {
          // do logout clear all login data and logout azure ad
          this.authenticationService.logout();
        }
      );
    }
  }
}
